#import "../../../shared/graphql/fragments/quote-money-fragment.graphql"

query GetQuotes($leadId: ID!) {
    quotes(leadId: $leadId) {
        id
        modalUrl
        displayStatus
        displayNumber
        total {
            ...QuoteMoneyFragment
        }
        slug
        shareableViewInBrowserLink
        sentTime
        createdTime
        publishedTime
        acceptedTime
    }
}
